import asArray from 'utils/arrays/asArray.util';
import flatMap from 'utils/functions/flatMap.util';

// flat map is basically flattening an array of arrays
// first we take item from the original array and make new one with the added separator
// then convert [ [item1,separator],[item2,separator] ] -> [item1,separator,item2,separator]
// and just remove the last element to have [item1,separator,item2]

const interleave = (separator, array) =>
  flatMap(
    // the mapper
    (item) => [item, separator],
    // just making sure null and undefined are handled
    asArray(array),
  )
    // make an array copy but without the last element
    .slice(0, -1);

// noinspection JSUnusedGlobalSymbols
export default interleave;
